import styled from 'styled-components';

export const Link = styled.a`
    font-size: ${({ theme }) => theme.fontSizes[4]};
    line-height: 1.4285714286;
    color: ${({ theme }) => theme.colors.fontPrimary};
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
`;
